import { useEffect, useState } from "react";

interface QuickDial {
  id: string;
  number: string;
  label: string;
  icon: string;
  variant: "primary" | "secondary";
}

const quickDials: QuickDial[] = [
  {
    id: "dial-112",
    number: "112",
    label: "All Emergency",
    icon: "ri-alarm-warning-line",
    variant: "primary",
  },
  {
    id: "dial-108",
    number: "108",
    label: "Ambulance",
    icon: "ri-truck-line",
    variant: "secondary",
  },
];

/** Sticky tap-to-call helplines that stay reachable while the page is scrolled. */
export default function CallEmergencyButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 420);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-5 right-4 z-40 flex flex-col items-end gap-2.5 md:bottom-6 md:right-6">
      {quickDials.map((dial, index) => {
        const isPrimary = dial.variant === "primary";
        return (
          <a
            key={dial.id}
            href={`tel:${dial.number}`}
            aria-label={`Call ${dial.number} — ${dial.label}`}
            title={`Call ${dial.number} — ${dial.label}`}
            style={{ transitionDelay: visible ? `${index * 60}ms` : "0ms" }}
            className={`inline-flex cursor-pointer items-center gap-2.5 rounded-full py-2.5 pl-2.5 pr-4 transition-all duration-300 ${
              isPrimary
                ? "bg-red-600 text-white ring-1 ring-red-700/30 hover:bg-red-700"
                : "bg-background-50 text-red-700 ring-1 ring-red-300 hover:bg-red-50"
            } ${visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"}`}
          >
            <span
              className={`relative flex h-9 w-9 flex-none items-center justify-center rounded-full ${
                isPrimary ? "bg-white/20" : "bg-red-100"
              }`}
            >
              <span
                className={`absolute inset-0 rounded-full ${
                  isPrimary ? "animate-ping bg-white/40" : "animate-ping bg-red-400/40"
                }`}
              />
              <i className={`${dial.icon} relative text-lg`} />
            </span>
            <span className="flex flex-col leading-tight">
              <span
                className={`text-[10px] font-semibold uppercase tracking-[0.12em] ${
                  isPrimary ? "text-white/80" : "text-red-700/70"
                }`}
              >
                {dial.label}
              </span>
              <span className="font-heading text-sm font-extrabold">Call {dial.number}</span>
            </span>
          </a>
        );
      })}
    </div>
  );
}